var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "38px",
    height: "38px",
    viewBox: "0 0 38.0 38.0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "i0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1440,0 L1440,1024 L0,1024 L0,0 L1440,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.8571429,0 C34.3357143,0 38,3.66428571 38,8.14285714 L38,29.8571429 C38,34.3357143 34.3357143,38 29.8571429,38 L8.14285714,38 C3.66428571,38 0,34.3357143 0,29.8571429 L0,8.14285714 C0,3.66428571 3.66428571,0 8.14285714,0 L29.8571429,0 Z M29.8571429,2.71428571 L8.14285714,2.71428571 C5.15714286,2.71428571 2.71428571,5.15714286 2.71428571,8.14285714 L2.71428571,29.8571429 C2.71428571,32.8428571 5.15714286,35.2857143 8.14285714,35.2857143 L29.8571429,35.2857143 C32.8428571,35.2857143 35.2857143,32.8428571 35.2857143,29.8571429 L35.2857143,8.14285714 C35.2857143,5.15714286 32.8428571,2.71428571 29.8571429,2.71428571 Z M18.3214286,25.7857143 C19.5428571,25.7857143 20.3571429,26.6 20.3571429,27.8214286 C20.3571429,29.0428571 19.5428571,29.8571429 18.3214286,29.8571429 C17.1,29.8571429 16.2857143,29.0428571 16.2857143,27.8214286 C16.2857143,26.6 17.1,25.7857143 18.3214286,25.7857143 Z M20.4928571,9.63571429 C24.1571429,9.63571429 26.4642857,11.8071429 26.4642857,14.6571429 C26.4642857,17.2357143 25.1071429,18.5928571 22.5285714,20.0857143 L21.85,20.3571429 C20.2214286,21.3071429 19.6785714,21.9857143 19.6785714,23.2071429 L17.2357143,23.2071429 C17.2357143,20.3571429 18.05,19.6785714 20.3571429,18.1857143 L20.7642857,17.9142857 C22.6642857,16.6928571 23.2071429,16.0142857 23.2071429,14.6571429 C23.2071429,13.3 22.1214286,12.2142857 20.0857143,12.2142857 C17.9142857,12.2142857 16.2857143,13.1642857 14.5214286,14.6571429 L12.6214286,12.4857143 C15.0642857,10.7214286 17.5071429,9.63571429 20.4928571,9.63571429 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1174.0 -559.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1047.0 526.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(126.0 32.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.0 1.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i1)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 38,0 38,38 0,38 0,0",
    stroke: "none",
    fill: "#00095B"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/Support.a3e15f6ff62254de6b5b3245d652e605.svg";
export { ForwardRef as ReactComponent };